import {
  BudgetRecommendations,
  MerchantAdCampaignConfigResponse,
  VenueAdCampaignConfigResponse,
} from 'apis/ad-bookings/types';
import { convertMonetaryIntToDecimal } from 'common/utils/currencyDecimals';
import { MerchantAdCampaignConfigFormValues, VenueAdCampaignConfigFormValues } from 'modules/campaigns/types';

import { BudgetOption } from '../components/types';

const mapBudgetOptions = (apiBudgetRecommendations: BudgetRecommendations, currency: Currency): BudgetOption[] =>
  Object.entries(apiBudgetRecommendations).map((option: [keyof typeof apiBudgetRecommendations, number]) => {
    return {
      type: option[0],
      value: convertMonetaryIntToDecimal(option[1], currency),
    };
  });

export const transformVenueAdCampaignConfig = (
  values: VenueAdCampaignConfigResponse,
): VenueAdCampaignConfigFormValues => ({
  currency: values.currency,
  budgetOptions: mapBudgetOptions(values.default_budget_amounts, values.currency),
  estimatedReturnOnSpending: values?.estimated_return_on_spending,
  minimumBidAmount: values.minimum_bid_amount,
  minimumBudgetAmount: values.minimum_budget_amount,
  maximumBudgetAmount: values.maximum_budget_amount,
  maximumCustomBidAmount: values.maximum_custom_bid_amount,
  freeTrialBudgetAmount: values.free_trial_budget_amount,
  freeTrialDurationWeeks: values.free_trial_duration_weeks,
});

export const transformMerchantAdCampaignConfig = (
  values: MerchantAdCampaignConfigResponse,
): MerchantAdCampaignConfigFormValues => ({
  currency: values.currency,
  budgetOptions: mapBudgetOptions(values.default_budget_amounts, values.currency),
  estimatedReturnOnSpending: values?.estimated_return_on_spending,
  minimumBidAmount: values.minimum_bid_amount,
  minimumBudgetAmount: values.minimum_budget_amount,
  maximumBudgetAmount: values.maximum_budget_amount,
  maximumCustomBidAmount: values.maximum_custom_bid_amount,
});
